"use client";

import { c as _c } from "react/compiler-runtime";
export function ChatEmpty() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-1 items-center justify-center p-4"><p className="text-center font-light text-foreground-muted">Send a message to start the conversation!</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}